import { FunctionComponent, ReactElement } from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { LoadingOverlay } from "components/atoms/loading-overlay";
import { authSelectors } from "core/store/modules/auth";
import { Dispatch, RootState } from "core/store/store.types";
import { User } from "core/types/user.types";

// Guardia di rotta per ruolo. Prima non esisteva: un cliente che digitava
// /web-rep/takedown o /web-rep/admin montava comunque il componente operatore e vedeva
// una pagina mezza rotta (le API rispondono 401/403, ma la UI c'era).
//
// NON e' una misura di sicurezza — il ruolo arriva da GET /account ed e' materiale del
// browser. L'autorizzazione vera resta sui decoratori del backend
// (simple_auth / legal_auth / admin_auth). Qui si evita solo di mostrare a un cliente
// una schermata che non gli appartiene.

interface OwnProps {
  roles: string[];
  children: ReactElement;
  // Dove rimbalzare chi non ha il ruolo. La dashboard e' l'unica pagina che tutti i
  // ruoli possono vedere.
  redirectTo?: string;
}

interface StateProps {
  user?: User;
}

interface DispatchProps {}

export type Props = OwnProps & StateProps & DispatchProps;

const RoleRoute: FunctionComponent<Props> = ({
  roles,
  children,
  redirectTo = "/web-rep/dashboard",
  user,
}) => {
  // GET /account risolve DOPO il primo render: senza questa attesa un admin che apre
  // /web-rep/admin da link diretto verrebbe rimbalzato prima di sapere chi e'.
  if (!user) return <LoadingOverlay open />;

  if (!roles.includes(user.role)) return <Navigate to={redirectTo} replace />;

  return children;
};

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  (state: RootState) => ({
    user: authSelectors.getUser(state),
  }),
  (dispatch: Dispatch) => ({})
)(RoleRoute);
